// import external dependencies
import slick from 'slick-carousel/slick/slick';
import isotope from 'isotope-layout/dist/isotope.pkgd';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import enquire from 'enquire.js/dist/enquire';
import Waypoint from 'waypoints/lib/jquery.waypoints';
import featherlight from 'featherlight/src/featherlight';
import featherlightGallery from 'featherlight/src/featherlight.gallery';
import datepickerFactory from 'jquery-datepicker/jquery-datepicker';
import datepickerDEFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-de';
import truncateInit from '../util/truncate';
import Cookies from 'js-cookie/dist/js.cookie';


// Pass jquery instance
datepickerFactory($);

export default {
    init() {
        const currentLang = $('.navigationMain__languageSwitcher li.current-lang a').attr('lang');

        // JavaScript to be fired on all pages
        function updateDatePickerField(id) {
            var date = $(id).datepicker('getDate');
            var day = date.getDate();
            var month = date.toLocaleString(currentLang, { month: 'short' });
            var year = date.getFullYear();
            if(window.dataLayer.quickBooking) {
                switch(id){
                    case "#arrival":
                        window.dataLayer.quickBooking.arrive = `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`;
                        break;
                    case "#departure":
                        window.dataLayer.quickBooking.depart = `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`;
                        break;
                    default:
                        break;
                }
            }
            $(id + 'Day').html(day);
            $(id + 'Month').html(month);
            $(id + 'Year').html(year);

            return date;
        }

        // Datepicker for arrival, settings + default
        $('#arrival').datepicker({
            // Get date value and print it to div (to make it stylable)
            onSelect: function () {
                let newArrivalDate = updateDatePickerField('#arrival');
                let departure = $('#departure');
                let currentDepartDate = departure.datepicker("getDate");
                if (currentDepartDate <= newArrivalDate) {
                    departure.datepicker("setDate", new Date(newArrivalDate.getTime() + 1000 * 60 * 60 * 24));
                    updateDatePickerField('#departure');
                }
                window.dataLayer.quickBooking.nights = Math.ceil(($('#departure').datepicker('getDate') - $('#arrival').datepicker('getDate')) / (1000 * 60 * 60 * 24));
            },
        }).datepicker("setDate", "0");

        // Datepicker for departure, settings + default
        $('#departure').datepicker({
            // Get date value and print it to div (to make it stylable)
            onSelect: function () {
                updateDatePickerField('#departure');
                window.dataLayer.quickBooking.nights = Math.ceil(($('#departure').datepicker('getDate') - $('#arrival').datepicker('getDate')) / (1000 * 60 * 60 * 24));
            },
        }).datepicker("setDate", "1");

        if (currentLang === 'de-DE') {
            datepickerDEFactory($);
            $.datepicker.regional['de'];
        }

        // Toggle mobile navigation
        $('#toggleNavigation').click(function (event) {
            event.preventDefault();
            $('#navigation').toggleClass('js_is-open');
        });

        // Close mobile navigation
        $('#closeNavigation').click(function (event) {
            event.preventDefault();
            $('#navigation').removeClass('js_is-open');
        });

        // Mobile subnavigation
        $('.navigationMain__openSub').click(function (event) {
            event.preventDefault();
            $(this).toggleClass('js_is-open');
            $(this).next().toggleClass('js_is-open');
        });

        // Show/hide searchform
        $('.header__openSearchform, .navigationMain__openSearchform').click(function (event) {
            event.preventDefault();
            $('#navigation').removeClass('js_is-open');
            $('#searchform').addClass('js_is-open');
        });

        // Show/hide searchform
        $('#closeSearchform').click(function (event) {
            event.preventDefault();
            $('#searchform').removeClass('js_is-open');
        });

        // Footer navigation toggle (mobile)
        $('.navigationFooter__link').click(function (event) {
            event.preventDefault();
            $(this).parent().toggleClass('js_is-open');
        });

        // Hotel room tab navigation
        // Make first items active on pageload
        $('a.rooms__navigationLink').addClass('js_is-inactive no-scroll');
        $('a.rooms__navigationLink').first().removeClass('js_is-inactive').addClass('js_is-active');
        $('article.room').first().addClass('js_is-active');
        // Mobile dropdown navi
        $('.rooms__navigationItems').on('click', '.rooms__navigationLink.js_is-active', function () {
            event.preventDefault();
            $(this).parent('.rooms__navigationItems').toggleClass('js_is-open');
        });
        $('.rooms__navigationItems').on('click', '.rooms__navigationLink.js_is-inactive', function () {
            event.preventDefault();
            var tab_id = $(this).attr('href');
            // Remove active items
            $('a.rooms__navigationLink').removeClass('js_is-active').addClass('js_is-inactive');
            $('article.room').removeClass('js_is-active');
            // Add new active items
            $(this).addClass('js_is-active').removeClass('js_is-inactive');
            $(tab_id).addClass('js_is-active');
            // Close mobile dropdown
            $(this).parent('.rooms__navigationItems').removeClass('js_is-open');
        });

        // Map infos mobile
        $('.mapInfos__title').click(function (event) {
            $(this).parent().toggleClass('js_is-active');
        });

        // Map infos desktop
        $('.mapInfos__navigationLink').click(function (event) {
            event.preventDefault();
            var targetId = $(this).attr('href');
            $(".mapInfos__navigationLink, .mapInfos__info").removeClass("js_is-active");
            $(this).addClass("js_is-active");
            $(targetId).addClass("js_is-active");
        });

        // Smooth scrolling for anchor links
        $(function () {
            $('a:not(.no-scroll)[href*="#"]:not([href="#"]), a.teaserCarousel__item').click(function () {
                if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    if (target.length) {
                        $('html, body').animate({
                            scrollTop: target.offset().top,
                        }, 700);
                        return false;
                    }
                }
            });
        });

        // Prepare sticky header
        var waypoints_header1 = $('#main').waypoint({
            handler: function (direction) {
                if (direction === 'down') {
                    $('#header').addClass("js_hide-sticky-menu");

                    $('.header__content').prepend('<div class="navigationMain__clone"></div>');
                    $('.navigationMain__content')
                        .clone()
                        .appendTo(".navigationMain__clone");

                    $('#toggleBookingForm')
                        .clone(true)
                        .removeClass("bookingForm__link")
                        .addClass("header__bookingLink button--primary")
                        .removeAttr('id')
                        .appendTo("#header");

                    $('#bookingFormContainer').removeClass("js_is-open").addClass("js_is-hidden");
                } else {
                    $('#header').removeClass("js_hide-sticky-menu");
                    $('#bookingFormContainer').addClass("js_is-open").removeClass("js_is-hidden");
                    $('.header__bookingLink').remove();
                    $('.navigationMain__clone').remove();

                    // Mobile: Remove class to close bookingform
                    enquire.register("screen and (max-width: 767px)", {
                        deferSetup: true,
                        match: function () {
                            $('#bookingFormContainer').removeClass("js_is-open");
                            $('.pageHeader__badge').removeClass("js_is-hidden-mobile");
                        },
                    });
                }
            },
            offset: '50%',
        })

        // More preparing
        var waypoints_header2 = $('#main').waypoint({
            handler: function (direction) {
                if (direction === 'down') {
                    $('#header').addClass("js_prepare-sticky-menu");
                    $('#bookingFormContainer').addClass("js_is-fixed");
                } else {
                    $('#header').removeClass("js_prepare-sticky-menu");
                    $('#bookingFormContainer').removeClass("js_is-fixed");
                }
            },
            offset: '20%',
        })

        // Show sticky header
        var waypoints_header3 = $('#main').waypoint({
            handler: function (direction) {
                if (direction === 'down') {
                    $('#header').addClass("js_has-sticky-menu");
                    $('#footer').addClass("js_show-backToTop");
                    $('#bookingFormContainer').addClass("js_is-visible");
                } else {
                    $('#header').removeClass("js_has-sticky-menu");
                    $('#footer').removeClass("js_show-backToTop");
                    $('#bookingFormContainer').removeClass("js_is-visible");
                }
            },
            offset: '-30%',
        });

        var waypoints_header4 = $('#woo-checkout').waypoint({
            handler: function (direction) {
                if (direction === 'down') {
                    if ($('#order_review').height() <= $(window).height() * 0.75) {
                        $('#order_review').addClass("order_fixed");
                    }
                } else {
                    $('#order_review').removeClass("order_fixed");
                }
            },
            offset: '-30%',
        });

        // Smooth scrolling for back-to-top-button
        $('#backToTop').click(function () {
            $('html, body').animate({ scrollTop: 0 }, 800);
            return false;
        });

        // Headerslider
        $('.pageHeader__content.js_isSlider').slick({
            dots: true,
            arrows: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
        });

        $('.dowload_slider.js_isSlider').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 500,
            slidesToShow: 4,
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow:3,
                    },
                },
                {
                    breakpoint: 550,
                    settings: {
                        slidesToShow:2,
                    },
                },
            ],
        });

        // Desktop menu mouseover classes
        $(".navigationMain__item.menu-item-has-children .navigationMain__link, .navigationMain__sub").mouseenter(function () {
            $("#pageHeader, #header").addClass('js_subNav-is-open');
        }).mouseleave(function () {
            $("#pageHeader, #header").removeClass('js_subNav-is-open');
        }); 

        // Room gallery slider
        $('.room__gallery').each(function (key, item) {
            // Create IDs
            var sliderIdName = 'room__gallery' + key;
            this.id = sliderIdName;
            var sliderId = '#' + sliderIdName;
            // Initialize slider
            $(sliderId).slick({
                dots: true,
                arrows: true,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
            });
        });

        // Izotope filtering
        $(function () {

            var $container = $('.teaserCollection');
            var filters = {};

            $container.imagesLoaded().progress(function () {
                $container.isotope({
                    itemSelector: '.teaserCollection__item',
                    layoutMode: 'fitRows',
                });
            });

            // Activate filter selection
            $('.filter__select').change(function () {
                var $this = $(this);

                // store filter value in object
                var group = $this.attr('data-filter-group');

                filters[group] = $this.find(':selected').attr('value');
                // convert object into array
                var isoFilters = [];
                for (var prop in filters) {
                    isoFilters.push(filters[prop]);
                }
                var selector = isoFilters.join('');
                $container.isotope({ filter: selector });
                // Show message, when no results are found
                if (!$container.data('isotope').filteredItems.length) {
                    $('#emptyFilter').show();
                } else {
                    $('#emptyFilter').hide();
                }
                return false;
            });

            // Activate filterTabs
            var $filters = $('.filterTabs').on('click', 'button', function () {
                var $this = $(this);
                var filterValue;
                if ($this.is('.js_is-active')) {
                    // Uncheck on toggle
                    filterValue = '*';
                } else {
                    filterValue = $this.attr('data-filter');
                    $filters.find('.js_is-active').removeClass('js_is-active');
                }
                // Add active class + filter
                $this.toggleClass('js_is-active');
                $container.isotope({ filter: filterValue });
            });
        });

        // Hotels map
        // Activate first item
        $('.hotelsMap__navigationLink').first().addClass('js_is-active');

        // iconTeaser slider
        $('.iconTeaser__items').each(function (key, item) {
            // Create IDs
            var sliderIdName = 'iconTeaserCarousel' + key;
            this.id = sliderIdName;
            var sliderId = '#' + sliderIdName;
            // Initialize slider
            $(sliderId).slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 500,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1179,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 767,
                    settings: "unslick",
                },
                ],
            });
        });

        // teaserCarousel slider
        $('.teaserCarousel').each(function (key, item) {
            // Create IDs
            if (!this.id) {
                var sliderIdName = 'teaserCarousel' + key;
                this.id = sliderIdName;
            }

            var sliderId = '#' + this.id;
            // Initialize slider
            $(sliderId).slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 500,
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                variableWidth: true,
                initialSlide: 1,
                responsive: [{
                    breakpoint: 1179,
                    settings: {
                        slidesToShow: 2,
                        centerMode: false,
                        variableWidth: false,
                        initialSlide: 0,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                        variableWidth: false,
                        initialSlide: 0,
                    },
                },
                ],
            });
        });

        // Hotel gallery slider settings
        var settings_gallery__slider = {
            dots: false,
            arrows: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            centerMode: true,
            variableWidth: true,
        }

        // Masonry gallery, when images are loaded
        var grid = document.querySelector('.gallery__content');
        if (grid) {
            imagesLoaded(grid, function () {
                // init Isotope after all images have loaded
                var msnry = new Masonry(grid, {
                    itemSelector: '.gallery__link',
                    columnWidth: '.gallery__sizer',
                    gutter: '.gallery__gutter',
                });
                if(window.location.hash.length > 0)
                    document.getElementById(window.location.hash.substring(1)).scrollIntoView();
            });
        }

        // Lightbox for masonry gallery
        $('a.gallery__link').featherlightGallery({
            previousIcon: '«',
            nextIcon: '»',
            galleryFadeIn: 300,
            openSpeed: 300,
        });

        // Close + open booking form
        $('#toggleBookingForm, #toggleBookingForm__clone').click(function (event) {
            event.preventDefault();
            $('#bookingFormContainer').toggleClass('js_is-open');
            $('.pageHeader__badge').toggleClass('js_is-hidden-mobile');
        });

        // Logo sliders
        // Settings slider 1
        var settings_logos_slider1 = {
            dots: false,
            arrows: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '#logos_slider2',
        }
        // Settings slider 2
        var settings_logos_slider2 = {
            dots: false,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '#logos_slider1',
        }

        // Media queries
        enquire.register("screen and (max-width: 767px)", {
            deferSetup: true,
            setup: function () {
                // Room gallery slider
                $('gallery__content').addClass('js_is-slider');
                $('.gallery__content.js_is-slider').slick(settings_gallery__slider);

                // Logo sliders
                $('#logos_slider1').not('.slick-initialized').slick(settings_logos_slider1);
                $('#logos_slider2').not('.slick-initialized').slick(settings_logos_slider2);

                // Close booking form for mobile
                $('#bookingFormContainer').removeClass('js_is-open');
            },
            match: function () {
                // Remove masonry for gallery
                $('.gallery__sizer').remove();
                $('.gallery__gutter').remove();
                $('.gallery__content').addClass('js_is-slider');
                // Turn gallery into slider
                $('.gallery__content.js_is-slider').slick(settings_gallery__slider);

                // Logo sliders
                $('#logos_slider1').not('.slick-initialized').slick(settings_logos_slider1);
                $('#logos_slider2').not('.slick-initialized').slick(settings_logos_slider2);
            },
            unmatch: function () {
                // Remove gallery slider
                $('.gallery__content.js_is-slider').slick('unslick');
                $('.gallery__content').removeClass('js_is-slider').prepend('<div class="gallery__sizer"></div><div class="gallery__gutter"></div>');

                // Remove logo sliders
                $('#logos_slider1').slick('unslick');
                $('#logos_slider2').slick('unslick');

                // Masonry gallery, when images are loaded
                var grid = document.querySelector('.gallery__content');
                if (grid) {
                    imagesLoaded(grid, function () {
                        // init Isotope after all images have loaded
                        var msnry = new Masonry(grid, {
                            itemSelector: '.gallery__link',
                            columnWidth: '.gallery__sizer',
                            gutter: '.gallery__gutter',
                            percentPosition: true,
                        });
                    });
                }

                // Open booking form for tablet + desktop
                $('#bookingFormContainer').addClass('js_is-open');
            },
        });

        // Show modals and set cookie to hide it then for
        jQuery(window).on('load', function () {
            var modal = $('#myModal');
            var modal_id = modal.attr('data-modal-id');
            var modal_expires = modal.data('modal-expires');
            var modal_delay = modal.attr('data-modal-delay');
            // Check, if cookie already exists
            if (Cookies.get(modal_id) !== '1') {
                // Set timeout for delay to show modal + set cookie
                setTimeout(function () {
                    $(modal).modal('show');
                    // Set cookie, when modal is closed
                    $(modal).on('hidden.bs.modal', function () {
                        Cookies.set(modal_id, '1', { expires: modal_expires }); // Can be changed by ACF
                    });
                }, modal_delay); // Can be changed by ACF
            }
        });

        //Dilvery Methode Toggle Switch...Voucher Plugin
        toggle_recipient_delivery_method();
        jQuery(document).on('click', '.woo-vou-delivery-method', function () {
            toggle_recipient_delivery_method();
        });

        function toggle_recipient_delivery_method() {
            jQuery('.woo-vou-recipient-delivery-method .woo-vou-delivery-method-wrapper label').each(function () {
                var input = jQuery(this).parent('.woo-vou-delivery-method-wrapper').find('input.woo-vou-delivery-method');
                if (jQuery(input).is(':checked')) {
                    jQuery(this).closest('.woo-vou-delivery-method-wrapper').nextAll().each(function () {
                        jQuery(this).show();
                        jQuery(this).find('input, textarea').removeAttr('disabled');
                    });
                } else {
                    jQuery(this).closest('.woo-vou-delivery-method-wrapper').nextAll().each(function () {
                        jQuery(this).hide();
                        jQuery(this).find('input, textarea').attr('disabled', 'disabled');
                    });
                }
            });
        }

        truncateInit();
    },
    finalize() {
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js